module.exports = __webpack_public_path__ + "img/Intel.908e550.svg";